import React, { useCallback, useEffect, useMemo } from 'react'
import { change } from 'redux-form'
import { connect } from 'react-redux'

import QuestionnaireCertificationInformationForm from '../../components/Questionnaires/QuestionnaireCertificationInformationForm'
import { asOptions } from '../../const/helper'

import { fetchStandards, fetchStandardScopes } from '../../actions/standards'

function prepareInitialValues (e) {
  let xstandards = { map: {}, array: [] }
  if (e.scopes) {
    xstandards = e.scopes.reduce((sum, x, i) => {
      if (!sum.map[x.standard.name]) {
        sum.map[x.standard.name] = {
          standard: x.standard,
          scope: [x.scope]
        }
        sum.array.push(x.standard.name)
      } else {
        sum.map[x.standard.name].scope.push(x.scope)
      }
      return sum
    }, { map: {}, array: [] })
  }
  return {
    standards: xstandards.array.map(x => xstandards.map[x]),
    detail: { ...e.detail },
    advance: e.detail.certification_information_complete
  }
}

export function QuestionnaireCertificationInformation (props) {
  const {
    accessToken,
    changeForm,
    fetchQuestionnaire,
    fetchStandards,
    fetchStandardScopes,
    questionnaire,
    standards,
    updateQuestionnaire,
    user
  } = props

  useEffect(() => {
    fetchStandards('?limit=1000', accessToken)
  }, [fetchStandards, accessToken])

  const fetchScopes = useCallback(
    (id) => fetchStandardScopes(id, accessToken),
    [fetchStandardScopes, accessToken]
  )

  const initialValues = useMemo(
    () => prepareInitialValues(questionnaire),
    [questionnaire]
  )

  const standardOptions = useMemo(
    () => asOptions(standards, 'name', 'id'),
    [standards]
  )

  function handleSubmit (e) {
    let target
    const request = {
      id: questionnaire.id,
      scopes: e.standards ? e.standards
        .reduce((sum, x, i) => ([...x.scope, ...sum]), [])
        .map(x => ({
          scope_id: x.id,
          standard_id: x.standard_id
        }))
        : null,
      detail: {
        ...e.detail
      }
    }
    if (user.data.role.includes('Customer')) {
      request.detail.input_by_customer = true
    }
    if (e.advance) {
      request.detail.certification_information_complete = true
      target = `/questionnaires/${questionnaire.id}/audit-location`
    }

    // if (request?.detail?.existing_certification?.length > 0) {
    //   const cleanUp = request.detail.existing_certification
    //     .filter((x) => x.filter)
    //     .map((x) => x.filter((y) => y && y != ''));
    //   if (cleanUp) {
    //     request.detail.existing_certification = cleanUp;
    //   }
    // }
    return updateQuestionnaire(request, accessToken, target).then((x) => {
      fetchQuestionnaire(questionnaire.id, accessToken)
    })
  }

  return (
    <div className='tab-pane active'>
      <h1>Certification Detail</h1>
      <div className='row'>
        <div className='col-md-8'>
          <p>Dear Sales Personnel, please fill in the customer detail form.</p>
          <QuestionnaireCertificationInformationForm
            standards={standardOptions}
            changeForm={changeForm}
            onSubmit={handleSubmit}
            initialValues={initialValues}
            onFetchScope={fetchScopes}
          />
        </div>
      </div>
    </div>
  )
}

function mapStateToProps (state) {
  return {
    standards: state.standards.standardList.data || [],
    user: state.auth.user
  }
}

function mapDispatchToProps (dispatch) {
  return {
    changeForm: (field, value) => dispatch(change('QuestionnaireCertificationInformationForm', field, value)),
    fetchStandards: (params, key) => dispatch(fetchStandards(params, key)),
    fetchStandardScopes: (id, key) => dispatch(fetchStandardScopes(id, key))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionnaireCertificationInformation)
